import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, map, of, switchMap } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { RoutingService } from '../routing/routing.service';
import {
  getOAuthParams,
  isOAuthParamsValid,
  redirectToHostedUiAuthorize,
} from './oauth-redirect';

export const loginRedirectGuard: CanActivateFn = (route): Observable<boolean | UrlTree> => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  const routingService = inject(RoutingService);
  const oAuthParams = getOAuthParams(route.queryParams);
  const hasValidOAuthParams = oAuthParams ? isOAuthParamsValid(oAuthParams) : false;

  return authenticationService.isValidSession().pipe(
    switchMap(isValidSession => {
      if (!isValidSession) {
        return of(true);
      }

      if (!hasValidOAuthParams || !oAuthParams) {
        return routingService.getPostLoginRoute().pipe(
          map((route) => router.createUrlTree([route]))
        );
      }

      return authenticationService.getEmail().pipe(
        map(email => {
          redirectToHostedUiAuthorize(oAuthParams, email);
          return false;
        })
      );
    })
  );
};